module.exports = __webpack_public_path__ + "static/chocolate_giftset-e8e106adee465195b4633a9ef8f83ef9.jpg";